import { CommonEnums } from 'src/app/shared/common.enums';

export class Output_Inst {
    public output_Inst_Id: number;
    public dxMp_Id: number;
    public nm: string;
    public description: string;
    public ver: string;
    public valid_Cd: string;
    public persistFlg: string;
    public updateBy: string;
    public lastUpdateBy: string;
    public updateDt: Date;
    public attr_Tab_Valid_Cd: string;
    public outmapr_Tab_Valid_Cd: string;

    constructor() {

    }

    setDefaults(): void {
        this.output_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.persistFlg = CommonEnums.defaults.STRING_VAL_NO;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date;
        this.attr_Tab_Valid_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.outmapr_Tab_Valid_Cd = CommonEnums.defaults.SUCCESS_CODE;
    }

    getPrimaryKey(): string {
        return this.output_Inst_Id + '.' + this.dxMp_Id;
    }

    copy(): Output_Inst {
        let output_InstTmp: Output_Inst = new Output_Inst();

        output_InstTmp.output_Inst_Id = this.output_Inst_Id;
        output_InstTmp.dxMp_Id = this.dxMp_Id;
        output_InstTmp.nm = this.nm;
        output_InstTmp.description = this.description;
        output_InstTmp.ver = this.ver;
        output_InstTmp.valid_Cd = this.valid_Cd;
        output_InstTmp.persistFlg = this.persistFlg;
        output_InstTmp.updateBy = this.updateBy;
        output_InstTmp.lastUpdateBy = this.lastUpdateBy;
        output_InstTmp.updateDt = this.updateDt;
        output_InstTmp.attr_Tab_Valid_Cd = this.attr_Tab_Valid_Cd;
        output_InstTmp.outmapr_Tab_Valid_Cd = this.outmapr_Tab_Valid_Cd;

        return output_InstTmp;
    }

    copyFrom(output_InstTmp: Output_Inst): void {
        this.output_Inst_Id = output_InstTmp.output_Inst_Id;
        this.dxMp_Id = output_InstTmp.dxMp_Id;
        this.nm = output_InstTmp.nm;
        this.description = output_InstTmp.description;
        this.ver = output_InstTmp.ver;
        this.valid_Cd = output_InstTmp.valid_Cd;
        this.persistFlg = output_InstTmp.persistFlg;
        this.updateBy = output_InstTmp.updateBy;
        this.lastUpdateBy = output_InstTmp.lastUpdateBy;
        this.updateDt = output_InstTmp.updateDt;
        this.attr_Tab_Valid_Cd = output_InstTmp.attr_Tab_Valid_Cd;
        this.outmapr_Tab_Valid_Cd = output_InstTmp.outmapr_Tab_Valid_Cd;
    }

    compare(output_InstTmp: Output_Inst): string {
        let output_InstString: string = this.toString(false);
        let output_InstTmpString: string = output_InstTmp.toString(false);

        if (output_InstString != output_InstTmpString) {
            return output_InstString + ', ' + output_InstTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "Output_Inst [output_Inst_Id=" + this.output_Inst_Id +
            ", dxMp_Id=" + this.dxMp_Id +
            ", nm=" + this.nm +
            ", description=" + this.description +
            ", ver=" + this.ver +
            ", valid_Cd=" + this.valid_Cd +
            ", persistFlg=" + this.persistFlg +
            ", updateBy=" + this.updateBy +
            ", updateDt=" + this.updateDt +
            ", attr_Tab_Valid_Cd=" + this.attr_Tab_Valid_Cd +
            ", outmapr_Tab_Valid_Cd=" + this.outmapr_Tab_Valid_Cd;

        if (isNotCompare) {
            str += ", lastUpdateBy=" + this.lastUpdateBy; 
        }

        str += ']';
        return str;
    }
}